export const LANGUAGE_KEY = 'peacetech-language';
/** Only the first preferred locale decides the automatic language. */
export function detectLanguage(browser) {
    const preferred = browser?.languages?.[0]?.trim() || browser?.language?.trim() || '';
    return /^zh(?:[-_]|$)/i.test(preferred) ? 'zh' : 'en';
}
export function resolveLanguage(browser, saved, requested) {
    if (requested === 'zh' || requested === 'en')
        return requested;
    if (saved === 'zh' || saved === 'en')
        return saved;
    return detectLanguage(browser);
}
export function readLanguage() {
    if (typeof window === 'undefined')
        return 'en';
    let saved = null;
    try {
        saved = window.localStorage.getItem(LANGUAGE_KEY);
    }
    catch { /* Storage can be unavailable. */ }
    return resolveLanguage(window.navigator, saved, new URL(window.location.href).searchParams.get('lang'));
}
export const language = readLanguage();
export const isEnglish = language === 'en';
export function setLanguage(choice) {
    try {
        if (choice === 'auto')
            window.localStorage.removeItem(LANGUAGE_KEY);
        else
            window.localStorage.setItem(LANGUAGE_KEY, choice);
    }
    catch { /* URL carries the explicit choice even when storage is blocked. */ }
    const url = new URL(window.location.href);
    if (choice === 'auto')
        url.searchParams.delete('lang');
    else
        url.searchParams.set('lang', choice);
    window.location.assign(url.href);
}
export function initializeLanguage(title, description) {
    document.documentElement.lang = isEnglish ? 'en' : 'zh-CN';
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
}
